import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { IUserMenuProps } from '../../Models/Constants/Interfaces';
import MsalAuthService from '../../Services/MsalAuthService';
import styles from './UserMenu.module.scss';
const cx = classNames.bind(styles);

export const UserMenu: React.FC<IUserMenuProps> = ({
    isUserMenuExpanded,
    selectedTenantId,
    setTenantId,
    tenants
}) => {
    const { t } = useTranslation();

    return (
        <div
            className={cx(
                'customUserMenu',
                { visible: isUserMenuExpanded },
                { slideIn: isUserMenuExpanded },
                { slideOut: !isUserMenuExpanded }
            )}
        >
            <div className={cx('menuElement')}>
                <div className={cx('menuElementSelectContainer')}>
                    <div>{t('directories')}</div>
                    <select
                        value={selectedTenantId || ''}
                        // eslint-disable-next-line no-restricted-globals
                        onChange={(event) => {setTenantId(event.target.value); location.reload();}}
                    >
                        {tenants.map((t: any, i: number) => (
                            <option key={i} value={t.tenantId}>
                                {t.displayName ? t.displayName : t.tenantId}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={cx('menuElement')}>
                <button
                    className={cx('menuElementButton')}
                    onClick={() => MsalAuthService.logout()}
                >
                    {t('logout')}
                </button>
            </div>
            <div className={cx('menuElement', 'tou')}>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={'https://aka.ms/adt-legal'}
                >
                    {t('termsOfUse')}
                </a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://aka.ms/adt-privacy"
                >
                    {t('privacyAndCookies')}
                </a>
            </div>
        </div>
    );
};
